import React, {FC} from 'react';
import {format} from 'date-fns';
import {WaitListData, WaitListIncentive} from 'graphql/types';

import * as styles from './styles.module.scss';

interface ProgressProps {
	data?: WaitListData;
}

interface Incentives {
	met?: WaitListIncentive
	unmet?: WaitListIncentive
}

const incentives = (data: WaitListData, captured: number) => {
	const ordered = (data.list?.incentives || []).sort((a, b) => b.target - a.target);
	return {
		met: ordered.reverse().find(({target}) => {
			return captured >= target;
		}),
		unmet: ordered.find(({target}) => {
			return captured < target;
		}),
	};
};

const motivation = ({met, unmet}: Incentives, captured: number) => {
	if (unmet) {
		// nothing met yet
		return `${unmet.target - captured} more sign-ups to ${unmet.outcome}!`;
	}
	return '';
};

export const Progress: FC<ProgressProps> = ({data}) => {
	if (!data) {
		return null;
	}

	const date = data.list?.due && format(new Date(data?.list?.due), 'MMMM dd');
	const captured = Math.max(data.list?.captured || 0, 0);
	const {met, unmet} = incentives(data, captured);
	const width = (unmet ? captured / unmet.target : 1) * 100;

	return (
		<>
			<span className={styles.title}>
				{date ?
					`Join the waitlist before it closes on ${date}` :
					'Join the waitlist!'}
			</span>
			<div className={styles.progressWrapper}>
				<div className={styles.spotsContainer}>
					<span className={styles.currentSpots}>{captured} on the waitlist</span>
					<span className={styles.remainingSpots}>
						{motivation({met, unmet}, captured)}
					</span>
				</div>
				<div className={styles.progressContainer}>
					<div className={styles.progress} style={{width: `${width}%`}} />
				</div>
			</div>
		</>
	);
};
